import { FacilityFieldsFragment } from '@/graphql/__generated/sdk';
import { Maybe, TOfficeInfo } from '@/types';

export const getHasOfficeInfo = (
	officeInfo?: FacilityFieldsFragment | null,
	officeLocationInfo?: TOfficeInfo | null
): boolean => {
	return !!(officeInfo || (officeLocationInfo && Object.keys(officeLocationInfo).length > 0));
};

export const replaceContentVars = ({
	text,
	officeInfo,
	officeLocationInfo,
}: {
	text?: Maybe<string>;
	officeInfo: FacilityFieldsFragment | null;
	officeLocationInfo: TOfficeInfo | null;
}) => {
	if (text && officeInfo) {
		let replacedText = text;
		const hasOfficeInfo = getHasOfficeInfo(officeInfo, officeLocationInfo);

		if (!hasOfficeInfo) {
			return replacedText;
		}

		const replacements: { [key: string]: string | undefined | null } = {
			'[phone]': officeInfo?.technicalInfrastructure?.phoneNumber ?? officeLocationInfo?.phoneNumber ?? '',
		};

		Object.keys(replacements).forEach((key) => {
			const value = replacements[key];
			if (value) {
				replacedText = replacedText.replace(key, value);
			}
		});
		return replacedText;
	}
	return text ?? '';
};
